module.exports = __webpack_public_path__ + "static/media/image_1.677a61a4.svg";